module.exports = __webpack_public_path__ + "static/media/linkedIn.c26fceca.png";